import React, { useState, useEffect } from 'react';
import { Fragment } from 'react';

import { WebAPI } from '../../MedicareProAPI/API/WebAPI';
import { PlanRepository } from '../../MedicareProAPI/Repositories/PlanRepository';
import { Utilities } from '../../MedicareProAPI/Utilities/Utilities';
import CommissionSingle from '../Components/CommissionSingle';
import AgentAnalyticsSchedulePanel from '../Panels/AgentAnalyticsSchedulePanel';
import AgentAnalyticsRenewalsPanel from '../Panels/AgentAnalyticsRenewalsPanel';
import AgentAnalyticsProductionPanel from '../Panels/AgentAnalyticsProductionPanel';

export default function AgentAnalyticsPage(props) {
  const [currentTab, setCurrentTab] = useState('production');

  const sections = [
    {
      id: 'production',
      label: 'Production',
      successClass: 'btn-primary',
      icon: 'fa-dollar-sign',
    },
    {
      id: 'renewals',
      label: 'Renewals',
      successClass: 'btn-success',
      icon: 'fa-chart-line',
    },
    {
      id: 'schedule',
      label: 'Schedule',
      successClass: 'btn-info',
      icon: 'fa-table',
    },
  ];

  return (
    <>
      <div className="row mb-3">
        <div className="col-12 px-2">
          {sections.map((tab) => {
            let buttonClassList = ['btn', 'btn-sm', 'mr-2'];

            if (currentTab === tab.id) {
              buttonClassList.push(tab.successClass);
            } else {
              buttonClassList.push('border-secondary');
            }

            let iconClassList = ['far', tab.icon];

            return (
              <span
                onClick={(e) => {
                  setCurrentTab(tab.id);
                }}
                key={tab.id}
                className={buttonClassList.join(' ')}
              >
                <i className={iconClassList.join(' ')}></i> {tab.label}
              </span>
            );
          })}
        </div>
      </div>

      {currentTab === 'schedule' && (
        <section className="ds">
          <AgentAnalyticsSchedulePanel {...props} />
        </section>
      )}
      {currentTab === 'renewals' && (
        <section className="ds">
          <AgentAnalyticsRenewalsPanel {...props} />
        </section>
      )}
      {currentTab === 'production' && (
        <section className="ds">
          <AgentAnalyticsProductionPanel {...props} />
        </section>
      )}
    </>
  );
}
